import apiClient from '../utils/apiClient';

class DishService {
    // Get all dishes for a restaurant
    async getDishes(restaurantId) {
        const response = await apiClient.get(`/restaurants/${restaurantId}/dishes`);
        return response;
    }

    // Get single dish
    async getDish(restaurantId, dishId) {
        const response = await apiClient.get(`/restaurants/${restaurantId}/dishes/${dishId}`);
        return response;
    }

    // Create new dish
    async createDish(restaurantId, dishData) {
        const response = await apiClient.post(`/restaurants/${restaurantId}/dishes`, { dishes: dishData });
        return response;
    }

    // Update dish
    async updateDish(restaurantId, dishId, dishData) {
        const response = await apiClient.patch(`/restaurants/${restaurantId}/dishes/${dishId}`, dishData);
        return response;
    }

    // Delete dish
    async deleteDish(restaurantId, dishId) {
        const response = await apiClient.delete(`/restaurants/${restaurantId}/dishes/${dishId}`);
        return response;
    }

    // Upload dish image
    async uploadDishImage(restaurantId, dishId, file) {
        const response = await apiClient.uploadFile(
            `/restaurants/${restaurantId}/dishes/${dishId}/image`,
            file
        );
        return response;
    }

    // Update dish availability
    async updateDishAvailability(restaurantId, dishId, isAvailable) {
        const response = await apiClient.patch(
            `/restaurants/${restaurantId}/dishes/${dishId}/availability`,
            { isAvailable }
        );
        return response;
    }

    // Get dish categories
    async getDishCategories(restaurantId) {
        const response = await apiClient.get(`/restaurants/${restaurantId}/dishes/categories`);
        return response;
    }

    // Search dishes
    async searchDishes(restaurantId, query, filters = {}) {
        const searchParams = { q: query, ...filters };
        const queryString = new URLSearchParams(searchParams).toString();
        const response = await apiClient.get(`/restaurants/${restaurantId}/dishes/search?${queryString}`);
        return response;
    }

    async importDishes(restaurantId, dishes, override = false) {
        const response = await apiClient.post(`/restaurants/${restaurantId}/dishes/import`, {
            dishes,
            override,
        });
        return response;
    }
}

const dishService = new DishService();
export default dishService;
